import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,

    CreateOrEditPurchaseDto,
    FindVendorOutputDto,
    DropDownLookupDto,
    FindProductOutputDto,

    TaxDto,
    CurrencyDto,
    GetPurchaseForEditInput,
    Status,
    ApplicableUnitForProduct,
    JournalDetailDto,
    ChartOfAccountDto,
    PurchaseNotesEditDto,
    PurchaseNotesDetailEditDto,
    PurchaseNotesServiceProxy,
    CreateOrUpdatePurchaseNotesInput,
    PurchaseNotesType,
    PaymentStatus,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-purchasenotes.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditPurchaseNotesComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('descriptionInputs') descriptionInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('subTotalInput') subTotalInput!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    vendorSelectedItem: FindVendorOutputDto;
    vendors: FindVendorOutputDto[];
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];

    filterText = '';

    purchaseNotes: PurchaseNotesEditDto = new PurchaseNotesEditDto();
    purchaseNotesDetails: PurchaseNotesDetailEditDto[];
    purchaseNotesDetail: PurchaseNotesDetailEditDto = new PurchaseNotesDetailEditDto();
    allChartOfAccounts: ChartOfAccountDto[];
    bankAccounts: ChartOfAccountDto[];
    vendorDisplayProperty = '';
    currencyName = '';
    paymentTermName = '';
    totalQty = 0;
    localTotal = 0;
    primaryCurrency = '';
    allCurrencys: CurrencyDto[];
    status = Status;
    type: number;
    headerText: string;
    description: string;
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('purchaseNotes'), '/app/purchase/purchaseNotess'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _purchaseNotesServiceProxy: PurchaseNotesServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {

        this.type = this._activatedRoute.snapshot.queryParams['type'];
        var purhchaseNotesType;

        if (this.type == 1) {
            this.headerText = this.l('CreateInvoice');
            this.description = this.l('CreateInvoiceHeaderInfo');
            purhchaseNotesType = PurchaseNotesType.PurchaseDebit;
        } else if (this.type == 2) {
            this.headerText = this.l('CreateCreditNotes');
            this.description = this.l('CreateCreditNotesHeaderInfo');
            purhchaseNotesType = PurchaseNotesType.PurchaseCredit;
        }
        else if (this.type == 3) {
            this.headerText = this.l('CreatePaymentToOthers');
            this.description = this.l('CreatePaymentToOthersHeaderInfo');
            purhchaseNotesType = PurchaseNotesType.PaymentToOthers;
        }

        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.purchaseNotesDetails.splice(index, 1);

        if (this.purchaseNotesDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.purchaseNotesDetails.forEach((c) => {
            c.slNo = i++;
        });
    }

    focusNext(type: 'description' | 'subTotal' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'description') {
            const next = this.descriptionInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'subTotal') {
            const next = this.subTotalInput.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.purchaseNotesDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.purchaseNotesDetails == null) this.purchaseNotesDetails = [];

        this.purchaseNotesDetail = new PurchaseNotesDetailEditDto();
        this.purchaseNotesDetail.slNo = this.purchaseNotesDetails.length + 1;
        this.purchaseNotesDetail.netTotal = 0;
        this.purchaseNotesDetail.tax = 0;
        this.purchaseNotesDetails.push(this.purchaseNotesDetail);
        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }

   
    show(purchaseNotesId?: number): void {
        if (!purchaseNotesId) {
            this.purchaseNotes = new PurchaseNotesEditDto();
            this.purchaseNotes.id = purchaseNotesId;
            this.purchaseNotes.transactionDate = this._dateTimeService.getStartOfDay();
            this.vendorDisplayProperty = '';
            this.currencyName = '';
            this.paymentTermName = '';
            this.purchaseNotes.currencyId = null;
            this.purchaseNotes.accountId = null;
            this.active = true;
        } else {
            this._purchaseNotesServiceProxy.getPurchaseNotesForEdit(purchaseNotesId).subscribe((result) => {
                this.purchaseNotes = result.purchaseNotes;
                this.purchaseNotesDetails = result.purchaseNotesDetailEditDtos;
               

                this.vendorSelectedItem = new FindVendorOutputDto();
                this.vendorSelectedItem.id = this.purchaseNotes.vendorId;
                this.vendorSelectedItem.displayName = result.purchaseNotes.vendorName;

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.purchaseNotes.id = null;
                    this.purchaseNotes.status = this.status.Draft;
                }
            });
        }

        this._commonLookupServiceProxy.getAllCurrencies().subscribe((result) => {
            this.allCurrencys = result;
        });
        
        this._commonLookupServiceProxy.getAllTaxes().subscribe((result) => {
            this.applicableTaxes = result;
        });

        this._commonLookupServiceProxy.getChartOfAccountForJournals().subscribe((result) => {
            this.allChartOfAccounts = result;
        });

        if (this.type == 3) {
            this._commonLookupServiceProxy.getBankAndCashAccount().subscribe((result) => {
                this.bankAccounts = result;
            });
        }
    }

    getCurrencyRate(value: any): void {
        var currency = this.allCurrencys.find((c) => c.id == value.target.value);
        var primaryCurrency = this.allCurrencys.find((c) => c.isPrimary == true);

        console.log(currency);
        this.purchaseNotes.currencyRate = currency.rate;

        this.primaryCurrency = primaryCurrency.name;
        this.calculateTotalValues();
    }

    getAccountCode(value: any, data: JournalDetailDto, index: number): void {

        debugger;
        var account = this.allChartOfAccounts.find(c => c.id == value.target.value);
        data.accountCode = account.code;
        data.accountId = value.target.value;
        this.focusNext('description', index);
    }

    searchAccount(accountCode: string, data: JournalDetailDto, index: number) {
        var account = this.allChartOfAccounts.find((c) => c.code == accountCode);
        if (account != null) {
            data.accountId = account.id;
            this.focusNext('description', index);
        } else {
            abp.notify.error('AccountNotFound');
            data.accountCode = '';
        }
    }

    amountCalculate(data: PurchaseNotesDetailEditDto) {
        var itemVendorDiscount = 0;
        debugger;
        let taxRate = 0;
        if (data.taxId > 0) {
            var tax = this.applicableTaxes.find((p) => p.id == data.taxId);
            taxRate = tax.taxPercentage;
            data.tax = parseFloat(((data.subTotal * taxRate) / 100).toFixed(2));
        } else {
            data.tax = 0;
        }
        data.netTotal = Number(data.subTotal) + Number(data.tax);
        this.purchaseNotes.roundingAmount = 0;
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        debugger
        var tempTotSubTotal = 0;
        var tempTotTaxAmt = 0;
        var tempTotNetTotal = 0;
        var tempGrandTotal = 0;
        var totalQty = 0;

        this.purchaseNotesDetails.forEach((val) => {
            var taxamt = 0;
            val.netTotal = Number(val.subTotal) + Number(val.tax);

            tempTotSubTotal = Number(tempTotSubTotal) + Number(val.subTotal);
            tempTotTaxAmt = Number(tempTotTaxAmt) + Number(val.tax);

            tempTotNetTotal = tempTotNetTotal + Number(val.netTotal);
        });
        this.purchaseNotes.subTotal = tempTotSubTotal;
        this.purchaseNotes.tax = tempTotTaxAmt;
        this.purchaseNotes.netTotal = tempTotSubTotal + tempTotTaxAmt;

        tempGrandTotal =
            this.purchaseNotes.netTotal +
            Number(this.purchaseNotes.roundingAmount);
        this.purchaseNotes.grandTotal = parseFloat(tempGrandTotal.toFixed(2));

        if (!isNaN(this.purchaseNotes.netTotal)) {
            this.localTotal = parseFloat((tempGrandTotal * Number(this.purchaseNotes.currencyRate)).toFixed(2));
        }
    }

    save(status: any): void {
        this.saving = true;

        this.purchaseNotes.status = status;
        var purchaseInput = new CreateOrUpdatePurchaseNotesInput();
        purchaseInput.purchaseNotes = this.purchaseNotes;
        purchaseInput.purchaseNotesDetails = this.purchaseNotesDetails;
        purchaseInput.purchaseNotes.type = this.type;
        purchaseInput.purchaseNotes.status = status;
        purchaseInput.purchaseNotes.grandTotal = this.localTotal;
        purchaseInput.purchaseNotes.paymentStatus = PaymentStatus.UnPaid;
        this._purchaseNotesServiceProxy
            .createOrEdit(purchaseInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.navigate();
            });
    }

    navigate() {
        if (this.type == 1) {
            this._router.navigate(['/app/account/purchaseNotes/invoices/1']);
        } else if (this.type == 2) {
            this._router.navigate(['/app/account/purchaseNotes/invoices/2']);
        }
        else if (this.type == 3) {
            this._router.navigate(['/app/account/purchaseNotes/invoices/3']);
        }
    }

    getVendor(vendor: FindVendorOutputDto) {
        this.purchaseNotes.vendorId = vendor.id;
    }

    goBack(): void {
        this._router.navigate(['/app/account/purchaseNotes/']);
    }
}
